export default __webpack_public_path__ + "static/media/delete.ff2b62cf.svg";